/**
 * Emoji + phrase d'appréciation selon le pourcentage de bonnes réponses (0-100),
 * pour l'écran de fin gamifié du Live School. Miroir du `finalAppreciation` du
 * showcase marketing (mêmes paliers) — dupliqué car apps/marketing n'est pas
 * importable depuis apps/app.
 */
export function finalAppreciation(scorePct: number): { emoji: string; headline: string } {
  if (scorePct >= 90) return { emoji: '🏆', headline: 'Excellent !' };
  if (scorePct >= 70) return { emoji: '🎉', headline: 'Bravo !' };
  if (scorePct >= 50) return { emoji: '👏', headline: 'Bien joué !' };
  return { emoji: '💪', headline: 'Continue comme ça !' };
}

/** « 1er », « 2e », « 12e ». PUR. */
export function ordinalFr(n: number): string {
  return n === 1 ? '1er' : `${n}e`;
}

/**
 * Titre de l'écran de fin d'un live : « Victoire ! » (1er sur plusieurs),
 * « GG ! » (au moins la moitié de bonnes réponses), sinon « Bien tenté ! » ;
 * puis « Tu termines 2e » / « sur 54 joueurs ». Sans rang : l'appréciation. PUR.
 */
export function finishHeadline(opts: {
  rank: number | null;
  total: number;
  correct: number;
  count: number;
}): { title: string; line1: string; line2: string | null; praise: string } {
  const pct = opts.count > 0 ? Math.round((opts.correct / opts.count) * 100) : 0;
  const title =
    opts.rank === 1 && opts.total > 1 ? 'Victoire !' : pct >= 50 ? 'GG !' : 'Bien tenté !';
  const praise =
    pct >= 90
      ? 'Un raisonnement sans faute !'
      : pct >= 50
        ? 'Tu as bien raisonné !'
        : 'Chaque erreur t’apprend quelque chose.';
  if (opts.rank != null) {
    return {
      title,
      line1: `Tu termines ${ordinalFr(opts.rank)}`,
      line2: opts.total > 1 ? `sur ${opts.total} joueurs` : null,
      praise,
    };
  }
  return { title, line1: finalAppreciation(pct).headline, line2: null, praise };
}
